import { Link, useParams } from 'react-router';
import { Hourglass } from 'lucide-react';
import { useT } from '@/i18n';
import { NAV_ITEMS } from '@/layout/nav';

/** Placeholder for nav items outside Pilot 1 ("Coming soon · phase P2"). */
export function ComingSoonPage() {
  const { feature = '' } = useParams();
  const { t } = useT();
  const item = NAV_ITEMS.find((n) => n.id === feature);
  return (
    <div className="page" style={{ maxWidth: 720 }}>
      <div className="card card-pad" style={{ gap: 14, padding: 28 }}>
        <Hourglass size={28} aria-hidden style={{ color: 'var(--blue-text)' }} />
        <div className="stack">
          <span className="label-caps">{t('comingSoonPhase', { phase: item?.soon ?? 'P2' })}</span>
          <h1 className="h1">{item ? t(item.label) : t('comingSoon')}</h1>
        </div>
        <p className="muted" style={{ margin: 0 }}>{t('comingSoonSub')}</p>
        <Link to="/" className="btn" style={{ justifySelf: 'start' }}>{t('goHome')}</Link>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  const { t } = useT();
  return (
    <div className="page" style={{ maxWidth: 720 }}>
      <div className="card card-pad" style={{ padding: 28 }}>
        <h1 className="h1">{t('notFoundTitle')}</h1>
        <p className="muted" style={{ margin: 0 }}>{t('errNotFound')}</p>
        <Link to="/" className="btn" style={{ justifySelf: 'start' }}>{t('goHome')}</Link>
      </div>
    </div>
  );
}
